export default {
  name: 'pulseSpin'
};